import { render, staticRenderFns } from "./BGEventTable.vue?vue&type=template&id=8fbbbe6c&scoped=true"
import script from "./BGEventTable.vue?vue&type=script&lang=js"
export * from "./BGEventTable.vue?vue&type=script&lang=js"
import style0 from "./BGEventTable.vue?vue&type=style&index=0&id=8fbbbe6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fbbbe6c",
  null
  
)

export default component.exports